module.exports = __webpack_public_path__ + "assets/img/AuditCover-w720.ad8ed99e.jpg";